module.exports = __webpack_public_path__ + "img/flat.3b715ddd.svg";